<template>
	<div class="campaigns-subview">
		<div class="subview-segment" v-if="party">
			<form-campaign-party :party="party"  :button-title="env.msg('bas.add')"
								 :campaign-title="env.msg('campaign.addPartyTo', '<b>'+partyName+'</b>')"
								 :empty-title="env.msg('err.empty')"
								 @refresh="refreshTable"></form-campaign-party>
		</div>
		<div class="subview-segment">
			<ui-root :part="root" :data="data" :readonly="false"></ui-root>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed, watch} from "vue";
import {connectEventBus, injectEnv} from "@fd/Environment.ts";
import {addContextParams, ContextKey, getIntValue, hasValue, injectContext, OPPORTUNITY_REFS} from "@t/fd/AppContext.ts";
import CrmTable from "@/vue/table/CrmTable.vue";
import FormCampaignParty from "@/vue/form/FormCampaignParty.vue";
import {SrcType} from "@t/meta/SourceType.ts";
import UiRoot from "@fd/containers/UiRoot.vue";
import {InterfaceRoot} from "@t/fd/InterfaceRoot.ts";
import {AGENDA_DIRTY, AgendaDefinition} from "@t/fd/layout/Agenda.ts";
import {ColumnType} from "@t/agenda/Columns.ts";
import {ActionFormatterData, IconFormatterData, WithFormatterData} from "@t/agenda/CellFormatter.ts";

const env = injectEnv();
const ctx = injectContext();
const sourceType = computed<number>(() => getIntValue(ctx.value, ContextKey.SRC_TYPE));
const sourceId = computed<string|number>(() => getIntValue(ctx.value, ContextKey.SRC_ID));
const bus = connectEventBus("CampaignsSubview");

const party = computed<number>(() => {
	if (sourceType.value === SrcType.PARTY) {
		let idValue = sourceId.value;
		return typeof idValue === "number" ? idValue : parseInt(idValue);
	}
	if (hasValue(ctx.value, ContextKey.PERSON)) return getIntValue(ctx.value, ContextKey.PERSON);
	if (hasValue(ctx.value, ContextKey.BRANCH)) return getIntValue(ctx.value, ContextKey.BRANCH);
	if (hasValue(ctx.value, ContextKey.CUSTOMER)) return getIntValue(ctx.value, ContextKey.CUSTOMER);
	return 0;
});

const partyName = ref<string>("");
watch(party, (pid) => {
	if (pid) {
		env.parties([ pid ]).then(names => {
			partyName.value = names.length > 0 ? names[0].name : "";
		});
	} else partyName.value = "";
}, { immediate: true });



const restApi = computed<string>(() => {
	let ep = "api/campaignparties/agendaSubview";
	ep = env.net.urlParam(ep, "srcType", sourceType.value);
	ep = env.net.urlParam(ep, "srcId", sourceId.value);
	return ep;
});

// Refactoring

const ap = computed<AgendaDefinition>(()=> {
	return {
		type: "agenda",
		name: "party_campaigns_subview",
		url: "api/parties/" + sourceId.value + "/campaigns",
		fixedColumns: [
			{
				name: "icon", title:"_icon_", type: ColumnType.STRING,
				layout: "LEFT",
				fixedWidth: "22px",
				icon: "ear", thitle: "",
				justify: "CENTER",
				jsonGetters: [ { d: "id" } ],
				format: <ActionFormatterData>{
					type: "ACTION",
					action: "edit",
					srcType: SrcType.CAMPAIGN_PARTY,
					format: <WithFormatterData>{
						type: "WITH",
						format: <IconFormatterData>{ type: "ICON" },
						data: ["ear"]
					},
					params: [ { name: "id", source: "ARG", index: 0 } ]
				}
			}
		]
	}
});

const root = computed<InterfaceRoot<AgendaDefinition>>(() => {
	return {
		type: "interface",
		content: ap.value,
	}
});

const data = computed<any>(() => {
	return { id: sourceId.value };
});

function refreshTable() {
	bus.fire(AGENDA_DIRTY, ap.value.name);
}


</script>

<style>

</style>